<template>
  <ElContainer
    id="app"
    direction="vertical"
  >
    <ElHeader
      height="51.2px"
      class="header"
    >
      <div style="float:left;">
        <i
          class="fa fa-bars fa-lg menu"
          style="cursor: pointer;"
          @click="showHideMenu()"
        ></i>
      </div>
      <div style="float:left;">
        <a href="https://www.mrc-asia.com/home">
          <img
            src="./assets/mrclogo.svg"
            alt="MRC Asia"
            class="logo"
          >
        </a>
      </div>
      <ul class="nav">
        <li class="nav-item header-item">
          <div style="float:left;">
            <ul style="margin:auto;">
              <li class="nav-item-comp">
                <ElButton
                  type="primary"
                  plain
                  round
                  class="btncomp"
                  @click="showHideMoreServices()"
                >
                  <ElButton
                    type="danger"
                    icon="el-icon-menu"
                    circle
                  ></ElButton>
                  More Services <i class="el-icon-caret-bottom"></i>
                </ElButton>
              </li>
            </ul>
          </div>
        </li>
        <li class="nav-item header-item">
          <Dropdown
            trigger="click"
            @command="handleCommand"
            class="dropdown"
          >
            <span>
              {{currentUser.username}}
              <i class="el-icon-caret-bottom el-icon--right"></i>
            </span>
            <DropdownMenu slot="dropdown">
              <DropdownItem
                v-if="isNewsTagger"
                command="newtagger"
              >News Tagger</DropdownItem>
              <DropdownItem
                v-if="isMdsUser"
                command="dataentry"
              >Edit Company Details</DropdownItem>
              <DropdownItem command="cp">Change Password</DropdownItem>
              <DropdownItem command="logout">Log out</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </li>
        <li class="nav-item header-item hidden-md-and-down">
          <a>
            <p></p>
          </a>
        </li>
        <li
          class="nav-item header-item hidden-xs-only"
          v-if="isMdsUser"
        >
          <i
            class="fa fa-lg"
            :class="classObject"
            aria-hidden="true"
            @click="setChatActive(!chatActive)"
          ></i>
        </li>
      </ul>
    </ElHeader>
    <ElContainer>
      <transition name="el-fade-in">
        <ElAside
          width="450px"
          v-show="showMoreServices"
          style="background-color:rgba(24,32,40,0.9);padding:20px 0 0 10px;"
          class="left-menu"
        >
          <div style="float:right">
            <div style="padding:5px 20px;">
              <i
                class="el-icon-d-arrow-left close-left-menu pull-right"
                @click="showHideMoreServices"
              ></i>
            </div>
          </div>
          <div style="float:left">
            <div
              v-for="(mitem,i) in moreservices"
              :key="`3${i}`"
              class="nav-menu-icon"
            >
              <ElButton
                :type="mitem.color"
                :disabled="mitem.disabled"
                @click="handleCommand(mitem.command)"
                style="width: 100%;  height: 100%; align-items: center; display: flex; flex-direction: row;"
              >
                <i
                  class="material-icons"
                  style="font-size:1.5em; width: 24px; height: 24px;"
                >
                  {{mitem.icon}}
                </i>
                <span
                  class="txt"
                  :class="{mute:mitem.disabled}"
                  v-html="mitem.module"
                ></span>
              </ElButton>
            </div>
          </div>
        </ElAside>
      </transition>
      <transition name="el-fade-in">
        <div
          v-show="chatActive"
          :style="{height:(windowHeight-52)*5/6+'px'}"
          class="chat-popup"
        >
          <Chatbox
            ref="chatbox"
            :msges="msges"
          ></Chatbox>
        </div>
      </transition>
      <transition name="el-fade-in">
        <ElAside
          width="280px"
          v-show="showMenu"
          style="background-color:rgba(24,32,40,0.9);"
          class="left-menu"
        >
          <ElMenu
            router
            unique-opened
            :default-openeds="openedMenu"
            :default-active="$route.path"
            background-color="rgba(24,32,40,0.5)"
            text-color="#fff"
            active-text-color="#ffd04b"
          >
            <div style="padding:10px 20px 5px;">
              <i
                class="el-icon-d-arrow-left close-left-menu pull-right"
                @click="hideMenu"
              ></i>
              <ElInput
                size="small"
                ref="menuSearch"
                autofocus
                v-model="searchMenu"
                class="translucent"
                placeholder="Search Menu..."
                prefix-icon="el-icon-search"
              >
              </ElInput>
            </div>
            <ElSubmenu
              index="1"
              v-show="toShow(menuKey.rewards,0)"
            >
              <div
                slot="title"
                :class="{'menu-disabled':!hasPayTrendAccess}"
              >
                <i class="fa fa-usd menu-icon"></i>
                <span class="lvl1">Pay Trends</span>
              </div>
              <ElMenuItem
                :disabled="!hasPayTrendAccess"
                v-show="toShow(menuKey.rewards.freshgradpay,0)"
                @click="hideMenu"
                index="/freshgradsal"
              >Bachelor/Master Degree Start Rates
              </ElMenuItem>
              <ElMenuItem
                :disabled="!hasPayTrendAccess"
                v-show="toShow(menuKey.rewards.wages,0)"
                @click="hideMenu"
                index="/minwage"
              >Wages (min,living,avg)</ElMenuItem>
            </ElSubmenu>
            <ElMenuItem
              v-show="toShow(menuKey.rewards.salaryBonusIncrease,0)"
              :disabled="!hasForecastCalculatorAccess"
              @click="hideMenu"
              index="/hrpredict"
            >
              <i class="fa fa-calculator menu-icon"></i>
              Salary Increase Predictor
            </ElMenuItem>
            <ElSubmenu
              index="2"
              v-show="toShow(menuKey.hrMarket,0)"
            >
              <div
                slot="title"
                :class="{'menu-disabled':!hasHrMarketAccess}"
              >
                <i class="fa fa-users menu-icon"></i>
                <span class="lvl1">Job Markets</span>
              </div>
              <ElMenuItem
                v-show="toShow(menuKey.hrMarket.jobPostings,0)"
                @click="hideMenu"
                :disabled="!hasHrMarketAccess"
                index="/job"
              >
                Job Postings
              </ElMenuItem>
              <ElMenuItem
                v-show="toShow(menuKey.hrMarket.talentIndicator,0)"
                :disabled="!hasHrMarketAccess"
                @click="hideMenu"
                index="/hr"
              >Talent Supply Indicators
              </ElMenuItem>
              <!-- toShow(menuKey.hrMarket.momentum,0) -->
              <ElMenuItem
                v-show="false"
                @click="hideMenu"
                :disabled="!hasHrMarketAccess"
                index="/hrMatrix"
              >
                HR Hiring Momentum
              </ElMenuItem>
            </ElSubmenu>
            <ElSubmenu
              index="3"
              v-show="toShow(menuKey.relocation,0)"
            >
              <div
                slot="title"
                :class="{'menu-disabled':!hasRelocationAccess}"
              >
                <i class="fa fa-globe menu-icon"></i>
                <span class="lvl1">Relocation</span>
              </div>
              <ElMenuItem
                v-show="toShow(menuKey.relocation.calc,0)"
                :disabled="!hasRelocationAccess"
                @click="hideMenu"
                index="/costofliving"
              >Relocation Calculator</ElMenuItem>
              <ElMenuItem
                v-show="toShow(menuKey.relocation.costOfLiving,0)"
                :disabled="!hasRelocationAccess"
                @click="hideMenu"
                index="/citiescost"
              >Cities Cost-of-Living Comparison</ElMenuItem>
              <ElMenuItem
                v-show="toShow(menuKey.relocation.costOfLivingTrends,0)"
                :disabled="!hasRelocationAccess"
                @click="hideMenu"
                index="/coltrends"
              >Cost-of-Living Trends</ElMenuItem>
            </ElSubmenu>
            <ElSubmenu
              index='4'
              v-show="toShow(menuKey.legislation,0)"
            >
              <div
                slot="title"
                :class="{'menu-disabled':!hasLegislationNewsAccess}"
              >
                <i class="fa fa-book menu-icon"></i>
                <span class="lvl1">Legislations & News</span>
              </div>
              <ElMenuItem
                :disabled="!hasLegislationNewsAccess"
                v-show="toShow(menuKey.legislation.employmentLegislation,0)"
                @click="hideMenu"
                index="/legislation"
              >
                Employment Legislation
              </ElMenuItem>
              <ElMenuItem
                :disabled="!hasLegislationNewsAccess"
                v-show="toShow(menuKey.legislation.news,0)"
                @click="hideMenu"
                index="/news"
              >
                News Updates
              </ElMenuItem>
            </ElSubmenu>
            <ElSubmenu
              index='5'
              v-show="toShow(menuKey.finance,0)"
            >
              <div
                slot="title"
                :class="{'menu-disabled':!hasFinanceProductivityAccess}"
              >
                <i class="fa fa-line-chart menu-icon"></i>
                <span class="lvl1">Financial / Productivity</span>
              </div>
              <ElMenuItem
                :disabled="!hasFinanceProductivityAccess"
                v-show="toShow(menuKey.finance.benchmarking,0)"
                @click="hideMenu"
                index="/fm"
              >
                Organisation/Productivity Benchmarking
              </ElMenuItem>
              <ElMenuItem
                :disabled="!hasFinanceProductivityAccess"
                v-show="toShow(menuKey.finance.gender,0)"
                @click="hideMenu"
                index="/gender"
              >
                Gender Diversity
              </ElMenuItem>
              <!-- toShow(menuKey.finance.momentum,0) -->
              <ElMenuItem
                :disabled="!hasFinanceProductivityAccess"
                v-show="false"
                @click="hideMenu"
                index="/companyMatrix/competitors"
              >
                Financial Momentum
              </ElMenuItem>
            </ElSubmenu>
            <ElMenuItem
              v-show="toShow(menuKey.econ,0)"
              @click="hideMenu"
              :disabled="!hasEconomyAccess"
              index="/macro"
            >
              <i class="fa fa-bank menu-icon"></i>
              Economy
            </ElMenuItem>
            <ElMenuItem
              v-if="isSuperAdmin"
              v-show="toShow(menuKey.admin,0)"
              @click="hideMenu"
              index="/admin"
            >
              <i class="fa fa-cogs menu-icon"></i>
              Admin module
            </ElMenuItem>
          </ElMenu>
        </ElAside>
      </transition>
      <ElMain>
        <transition name="el-fade-in">
          <keep-alive>
            <router-view class="content"></router-view>
          </keep-alive>
        </transition>
      </ElMain>
    </ElContainer>
  </ElContainer>
</template>

<script>
// import Vue from 'vue';
import {
  Container,
  Header,
  Aside,
  Main,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Menu,
  Submenu,
  MenuItemGroup,
  MenuItem,
  Input,
  Notification,
  Button,
} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import { mapState, mapActions, mapMutations } from 'vuex';

import Chatbox from './components/Chatbox';
import permCheck from './util/permCheck';
import debounce from './util/debounce';
// import '../static/css/theme/index.css';

// Vue.prototype.$ELEMENT = { size: 'small' };

export default {
  name: 'app',
  components: {
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Chatbox,
    ElMenu: Menu,
    ElSubmenu: Submenu,
    ElMenuItemGroup: MenuItemGroup,
    ElMenuItem: MenuItem,
    ElContainer: Container,
    ElHeader: Header,
    ElMain: Main,
    ElAside: Aside,
    ElInput: Input,
    ElButton: Button,
  },
  data() {
    return {
      windowHeight: 500,
      opened: [],
      menuKey: {
        rewards: {
          salaryBonusIncrease: ['salary', 'bonus', 'predict', 'rewards'],
          freshgradpay: ['fresh graduate pay', 'rewards'],
          wages: [
            'min wages',
            'minimum wages',
            'social wage',
            'living wage',
            'rewards',
          ],
          supercomp: ['super comp', 'rewards'],
          dcc: ['data collection center', 'rewards'],
        },
        hrMarket: {
          jobPostings: ['job postings', 'hr market'],
          // uniGrad: ['university graduates', 'uni grad', 'hr market'],
          talentIndicator: ['talent', 'supply', 'indicators', 'hr market'],
          momentum: ['hr momentum', 'hiring'],
        },
        relocation: {
          calc: ['relocation calculator'],
          balanceSheet: ['relocation balance sheet'],
          costOfLiving: ['cost of living cities city'],
          costOfLivingTrends: ['cost of living trends'],
        },
        legislation: {
          employmentLegislation: ['employment legislations'],
          news: ['news', 'legislation'],
        },
        finance: {
          benchmarking: ['financial productivity benchmarking'],
          gender: ['financial productivity gender diversity'],
          momentum: ['momentum', 'pressure'],
        },
        econ: ['economy', 'gdp', 'inflation', 'unemployment', 'investment'],
        admin: ['admin'],
      },
      searchMenu: '',
      showMenu: false,
      showMoreServices: false,
    };
  },
  methods: {
    toShow(item, level) {
      if (level > 5) return true;
      if (typeof item === 'object') {
        if (Array.isArray(item)) {
          const searchMenu = this.searchMenu.toLowerCase();
          for (let i = 0; i < item.length; i += 1) {
            if (item[i].includes(searchMenu)) {
              return true;
            }
          }
        } else {
          const iKeys = Object.keys(item);
          for (let i = 0; i < iKeys.length; i += 1) {
            if (this.toShow(item[iKeys[i]], level + 1)) {
              return true;
            }
          }
        }
      }
      return false;
    },
    showHideMoreServices() {
      this.showMenu = false;
      if (!this.showMoreServices) {
        this.showMoreServices = true;
      } else {
        this.showMoreServices = false;
      }
    },
    showHideMenu() {
      this.showMoreServices = false;
      if (!this.showMenu) {
        this.showMenu = true;
        this.$nextTick(() => this.$refs.menuSearch.$refs.input.focus());
      } else {
        this.showMenu = false;
      }
    },
    hideMenu(index) {
      if (index && index.indexPath) {
        this.opened = index.indexPath;
      }
      this.showMenu = false;
      this.searchMenu = '';
    },
    handleCommand(command) {
      switch (command) {
        case 'exec-comp-public':
          window.location.href = '/exec-comp/#/public';
          break;
        case 'exec-comp-private':
          window.location.href = '/exec-comp-private';
          break;
        case 'super-comp-ml':
          window.location.href = '/super-comp';
          break;
        case 'super-comp-actual':
          window.location.href = '/core-comp';
          break;
        case 'employee-benefits':
          window.location.href = '/employee-benefits';
          break;
        case 'mi':
          window.location.href = '/mi';
          break;
        case 'sip':
          window.location.href = '/sip';
          break;
        case 'on-demand-survey':
          window.location.href = '/dcc/#/basic-comp';
          break;
        case 'job-evaluation':
          window.location.href = '/jes';
          break;
        case 'market-insight':
          window.location.href = '/market_insights_members';
          break;
        case 'aims':
          this.showHideMenu();
          break;
        case 'dataentry':
          this.$router.push('/companyinfo');
          break;
        case 'logout':
          this.logout();
          break;
        case 'cp':
          window.location.href = '/sign/auth/cp?source=/aims';
          break;
        case 'newtagger':
          this.$router.push('/newstagger');
          break;
        case 'symposium':
          window.location.href = '/seminar_members';
          break;
        case 'erp':
          window.location.href = '/erp';
          break;
        default:
      }
    },
    ...mapMutations([
      'setUnread',
      'addOnlineContacts',
      'removeOnlineContact',
      'setChatActive',
    ]),
    ...mapActions([
      'initNewsData',
      'initFinanceData',
      'initEchartsMap',
      'logout',
      'getCurrentUser',
      'getAllInstitutionalIndexes',
      'getAllCostPressures',
      'getAllSalaryCostPressures',
      'getAllRevMomentums',
      'getAllExpansionThreats',
      'initCountries',
      'getCustomersNote',
      'getSuppliersNote',
      'getCompetitorsNote',
      'getInstitutionNote',
      'getDisruptorsNote',
      'getNewsIndex',
      'getJobDemandMatrix',
      'initJobCountries',
      'getJobSupplyMatrix',
      'getHrIndicators',
      'getRegionsGroup',
      'setAllRead',
      'getMinWageCountries',
      'initHrCategory',
      'getCostOfLivingCities',
      'getSpendingMultiplier',
      'getCurrencies',
      'getAllContacts',
      'initChat',
      'sendMessage',
      'getUnreadMsges',
      'getChatStatus',
      // 'initExecutivePayData',
      'getImfIndicatorMetas',
      'getIndicatorsMetas',
    ]),
  },
  computed: {
    moreservices() {
      return [
        {
          module: 'Executive Compensation Public',
          color: 'warning',
          icon: 'people',
          command: 'exec-comp-public',
          disabled: !this.isExecCompPublic,
        },
        {
          module: 'Executive Compensation Private',
          color: 'danger',
          icon: 'assignment_ind',
          command: 'exec-comp-private',
          disabled: !this.isExecCompPrivate,
        },
        {
          module: 'Super Compensation',
          color: 'primary',
          icon: 'adb',
          command: 'super-comp-ml',
          disabled: !this.isSuperComp,
        },
        {
          module: 'Employee Benefits',
          color: 'warning',
          icon: 'card_membership',
          command: 'employee-benefits',
          disabled: !this.isEmployeeBenefits,
        },
        {
          module: 'APAC Market Insights',
          color: 'info',
          icon: 'bar_chart',
          command: 'mi',
          disabled: !this.isMI,
        },
        {
          module: 'Sales Incentive Practices',
          color: 'primary',
          icon: 'store',
          command: 'sip',
          disabled: !this.isSIP,
        },
        {
          module: 'Job Evaluation System',
          color: 'danger',
          icon: 'table_chart',
          command: 'job-evaluation',
          disabled: !this.isJes,
        },
        {
          module: 'Employee Risk Predictor',
          color: 'info',
          icon: 'cloud',
          command: 'erp',
          disabled: !this.isErp,
        },
        {
          module: 'Symposium Materials',
          color: 'warning',
          icon: 'description',
          command: 'symposium',
          disabled: !this.isMaterials,
        },
        {
          module: 'Monthly Market Insights',
          color: 'danger',
          icon: 'system_update',
          command: 'market-insight',
          disabled: !this.isEconGuide,
        },
        {
          module: 'AI Market Sensor for HR',
          color: 'primary',
          icon: 'view_comfy',
          command: 'aims',
          disabled: false,
        },
      ];
    },
    openedMenu() {
      if (this.searchMenu.trim().length > 0) {
        return ['1', '2', '3', '3-1', '4', '5'];
      }
      return this.opened;
    },
    isNewsTagger() {
      return permCheck(this.currentUser, ['news_tagger', 'all']);
    },
    hasPayTrendAccess() {
      return permCheck(this.currentUser, ['mds', 'all', 'pay_trends']);
    },
    hasForecastCalculatorAccess() {
      return permCheck(this.currentUser, ['mds', 'all', 'forecast_calculator', 'aims.nonrewards']);
    },
    hasHrMarketAccess() {
      return permCheck(this.currentUser, ['mds', 'all', 'hr_markets', 'aims.nonrewards']);
    },
    hasRelocationAccess() {
      return permCheck(this.currentUser, ['mds', 'all', 'relocation', 'aims.nonrewards']);
    },
    hasLegislationNewsAccess() {
      return permCheck(this.currentUser, ['mds', 'all', 'legislations_news', 'aims.nonrewards']);
    },
    hasFinanceProductivityAccess() {
      return permCheck(this.currentUser, [
        'mds',
        'all',
        'finance_productivity',
        'aims.nonrewards',
      ]);
    },
    hasEconomyAccess() {
      return permCheck(this.currentUser, ['mds', 'all', 'economy', 'aims.nonrewards']);
    },
    isMdsUser() {
      return permCheck(this.currentUser, [
        'mds',
        'aims.nonrewards',
        'all',
        'forecast_calculator',
        'hr_markets',
        'pay_trends',
        'relocation',
        'legislations_news',
        'finance_productivity',
        'economy',
      ]);
    },
    isExecCompPublic() {
      return permCheck(this.currentUser, ['all', 'exec_comp_public']);
    },
    isExecCompPrivate() {
      return permCheck(this.currentUser, ['all', 'exec_comp_private']);
    },
    isJes() {
      return permCheck(this.currentUser, ['all', 'jes']);
    },
    isErp() {
      return permCheck(this.currentUser, ['all', 'erp']);
    },
    isMaterials() {
      return permCheck(this.currentUser, ['all', 'seminar_material']);
    },
    isEconGuide() {
      return permCheck(this.currentUser, ['all', 'econ_guide']);
    },
    isSuperComp() {
      return permCheck(this.currentUser, ['all', 'super_comp']);
    },
    isEmployeeBenefits() {
      return permCheck(this.currentUser, ['all', 'employee_benefits']);
    },
    isMI() {
      return permCheck(this.currentUser, ['all', 'mi_survey']);
    },
    isSIP() {
      return permCheck(this.currentUser, ['all', 'sip']);
    },
    isSuperAdmin() {
      return permCheck(this.currentUser, ['all']);
    },
    unread() {
      const msges = this.msges;
      const currentUserId = this.currentUser.userid;
      const users = Object.keys(msges);
      for (let i = 0; i < users.length; i += 1) {
        const msgIndex = msges[users[i]].findIndex(
          m => m.fromUserId !== currentUserId && m.readTimestamp === '',
        );
        if (msgIndex >= 0) return true;
      }
      return false;
    },
    classObject() {
      return {
        'fa-comments-o': !this.unread,
        'fa-commenting': this.unread,
        unreadColor: this.unread,
        'fa-lg': this.unread,
      };
    },
    isActive() {
      return (
        this.$route.path === '/macro' ||
        this.$route.path === '/fm' ||
        this.$route.path === '/orgstructure' ||
        this.$route.path === '/job' ||
        this.$route.path === '/hr' ||
        this.$route.path === '/minwage' ||
        this.$route.path === '/hrpredict' ||
        this.$route.path === '/costofliving' ||
        this.$route.path === '/freshgradsal' ||
        this.$route.path === '/exePay'
      );
    },
    ...mapState(['currentUser', 'msges', 'majorCurrencies', 'chatActive']),
  },
  mounted() {
    this.windowHeight = window.innerHeight;
    const resizeDebounced = debounce(() => {
      this.windowHeight = window.innerHeight;
    }, 500);
    window.addEventListener('resize', resizeDebounced);
    this.$router.beforeEach((to, from, next) => {
      if (
        to.matched.some(
          record => !permCheck(this.currentUser, record.meta.permissions),
        )
      ) {
        next(false);
        return;
      }
      next();
    });
    this.getCurrentUser().then(() => {
      if (
        permCheck(this.currentUser, [
          'aims.nonrewards',
          'mds',
          'all',
          'forecast_calculator',
          'hr_markets',
          'pay_trends',
          'relocation',
          'legislations_news',
          'finance_productivity',
          'economy',
        ])
      ) {
        this.getChatStatus();
        this.initChat();
        this.getCompetitorsNote();
        this.getSuppliersNote();
        this.getCustomersNote();
        this.getInstitutionNote();
        this.getDisruptorsNote();
        this.getCostOfLivingCities();
        this.getSpendingMultiplier();
        this.initEchartsMap();
        this.initFinanceData();
        this.initNewsData();
        this.getAllInstitutionalIndexes();
        this.getAllCostPressures();
        this.getAllSalaryCostPressures();
        this.getAllRevMomentums();
        this.getAllExpansionThreats();
        this.getNewsIndex();
        this.initCountries();
        this.initJobCountries();
        this.getJobDemandMatrix();
        this.getJobSupplyMatrix();
        this.getHrIndicators();

        this.getCurrencies(this.majorCurrencies);
        this.getAllContacts();
        this.getUnreadMsges();
        this.getImfIndicatorMetas();
        this.getIndicatorsMetas();
        if ('Notification' in window) {
          window.Notification.requestPermission();
        }
      }
      if (permCheck(this.currentUser, ['mds', 'all', 'pay_trends'])) {
        this.getMinWageCountries();
        // this.initExecutivePayData();
      }
      if (
        permCheck(this.currentUser, [
          'news_tagger',
          'all',
          'mds',
          'aims.nonrewards',
          'forecast_calculator',
          'hr_markets',
          'pay_trends',
          'relocation',
          'legislations_news',
          'finance_productivity',
          'economy',
        ])
      ) {
        this.initHrCategory();
        this.getRegionsGroup();
      }

      if (this.$router.currentRoute.path === '/') {
        if (permCheck(this.currentUser, ['news_tagger'])) {
          this.$router.push('/newstagger');
        } else if (
          permCheck(this.currentUser, [
            'all',
            'mds',
            'aims.nonrewards',
            'legislations_news',
          ])
        ) {
          this.$router.push('/news/hr');
        }
      }

      if (this.currentUser.cp) {
        Notification({
          title: 'Reminder',
          type: 'warning',
          message: this.$createElement(
            'a',
            {
              attrs: {
                href: '/sign/auth/cp?source=/aims',
              },
            },
            'Please change your password',
          ),
          duration: 0,
          offset: 70,
        });
      }
    });
  },
};
</script>

<style lang="scss">
$active-color: white;
$hover-color: lighten(#1ad5fc, 5%);
$bg-color: #e9ebee;
// $header-color: #3b5998;
$header-color: #f5f5f5;
$header-fg-color: rgba(0, 0, 0, 0.87);
$fg-color: #1d2129;
$header-height: 3.2;
body {
  font-family: Calibri, Candara, Segoe, 'Segoe UI', Optima, Arial, sans-serif;
  margin: 0;
  background-color: $bg-color;
  color: $fg-color;
}
// button {
//     display: inline-block;
//     line-height: 1;
//     white-space: nowrap;
//     cursor: pointer;
//     background: #fff;
//     border: 1px solid #bfcbd9;
//     color: #1f2d3d;
//     margin: 0;
//     padding: 10px 15px;
//     border-radius: 4px;
// }
.chat-popup {
  position: fixed;
  top: 42px;
  right: 10px;
  width: 400px;
  background-color: white;
  padding: 0;
  border: 1px solid #e6ebf5;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.chat-popup::after {
  content: ' ';
  position: absolute;
  bottom: 100%; /* At the bottom of the tooltip */
  right: 10%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent white transparent;
}
.unreadColor {
  color: #f7ba2a;
  // color: #fa3e3e;
}
// button.primary {
//     color: #fff;
//     background-color: #20a0ff;
//     border-color: #20a0ff;
// }
.logo {
  margin-top: ($header-height * 0.25) + rem;
  margin-bottom: ($header-height * 0.25) + rem;
  height: ($header-height * 0.5) + rem;
}
.header {
  position: fixed;
  left: 0;
  right: 0;
  background-color: $header-color;
  color: $header-fg-color;
  height: $header-height + rem;
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14),
    0 1px 10px 0 rgba(0, 0, 0, 0.12);
  .menu {
    float: left;
    line-height: $header-height + rem;
    background: transparent;
    margin: 0 3rem 0 0.5rem;
  }
  .top-menu {
    float: right;
    line-height: ($header-height - 0.3) + rem;
    padding: 0;
    margin: 0;
    z-index: 3;
  }
  .nav {
    float: right;
    line-height: ($header-height - 0.3) + rem;
    background: transparent;
    padding: 0;
    margin: 0;
    z-index: 3;
    .router-link-active {
      border-bottom: 0.1rem solid $active-color;
      color: $active-color;
    }
    .header-item {
      min-width: 3rem;
    }
  }
  .nav-item {
    float: left;
    list-style: none;
    position: relative;
    cursor: pointer;
    // margin-left: 10px;
    a,
    span {
      color: $header-fg-color;
      text-decoration: none;
      display: block;
      padding: 0 20px;
      opacity: 0.9;
      // border-bottom: 0.2rem solid $active-color;
    }
    a:hover {
      border-bottom: 0.1rem solid $hover-color;
      color: $hover-color;
    }
    .dropdown {
      font-size: 1rem;
    }
  }
  .nav-item-comp {
    float: left;
    list-style: none;
    position: relative;
    cursor: pointer;
    margin-top: 2px;
    margin-right: 10px;
    a,
    span {
      color: rgb(107, 20, 20);
      text-decoration: none;
      font-weight: 600;
      font-size: 0.8rem;
      display: block;
      padding: 0 20px;
      opacity: 0.9;
      // border-bottom: 0.2rem solid $active-color;
    }
    a:hover {
      border-bottom: 0.1rem solid $hover-color;
      color: $hover-color;
    }
    .dropdown {
      font-size: 1rem;
    }
    .btncomp {
      margin: 0;
      padding: 0;
    }
  }
}
.content {
  position: fixed;
  left: 0;
  right: 0;
  top: $header-height + rem;
  bottom: 0;
  padding: 0.6rem;
  z-index: -1;
  // background-color: lightblue;
  overflow-y: auto;
  // font-size: 1rem;
}
.left-menu {
  position: fixed;
  left: 0;
  top: $header-height + rem;
  padding-right: 3px;
  bottom: 0;
  z-index: 1;
  overflow-y: auto;
  .menu-disabled {
    color: #555b61;
    .menu-icon {
      color: #555b61;
    }
  }
  .menu-icon {
    margin-right: 5px;
    width: 24px;
    text-align: center;
    font-size: 18px;
    color: #fff;
  }
  .lvl1 {
    font-weight: 500;
    font-size: 16px;
    // color: #bfb;
  }
  .lvl2 {
    // font-weight: normal;
    font-size: 16px;
    // color: #fbb;
  }
  .close-left-menu {
    color: white;
    padding-bottom: 10px;
    cursor: pointer;
  }
}
.nav-menu-icon {
  width: 90%;
  float: left;
  margin: 5px 2px;
  padding: 2px 2px;
  // border: 1px solid #fff;
  color: #fff;
  text-align: center;
  .txt {
    height: 24px;
    font-size: 1.3em;
    margin-left: 2px;
  }
  .mute {
    color: gray;
  }
}
.translucent {
  .el-input__inner {
    background-color: rgba(4, 12, 20, 0.3);
    color: #c8ecfe;
  }
}
.table.table-condensed {
  width: 100%;
  max-width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
  thead th {
    text-align: left;
  }
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// App.vue?d0873378